import { getSections } from '@/api'
import { ref, computed, ComputedRef } from '@vue/composition-api'
import store from '@/store'

type Term = {
  year: number | string,
  semester: number | string,
}

type Course = {
  sisId?: string,
  courseGroupId: string,
  code?: string,
  customFields?: {
    rawCourseId?: string,
  }
}

type Section = {
  sectionNumber: number
}

interface Args {
  course: Course,
  term: Term,
  sectionNumber?: string | number,
}

const state = ref({
  sections: {},
})

export default function useSections () {
  const sections: ComputedRef<Section[]> = computed(() => Object.values(state.value.sections))

  function getSectionBySectionNumber (sectionNumber?: string | number) {
    if (!sectionNumber) return {}
    return sections.value.find((s: Section) => s.sectionNumber === sectionNumber)
  }

  async function fetchSectionsByCmCourse ({ course, term, sectionNumber }: Args) {
    const possibleCourseIds = [
      course.courseGroupId,
      course.sisId,
      course.code,
      course.customFields?.rawCourseId,
    ].filter(Boolean)

    const data = await getSections({
      school: store.getters.school,
      year: term.year,
      semester: term.semester,
      list: possibleCourseIds,
      listField: 'courseId',
      ...(sectionNumber ? { sectionNumber } : {}),
    }) || []

    state.value.sections = data
  }

  return {
    sections,
    fetchSectionsByCmCourse,
    getSectionBySectionNumber,
  }
}
